<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import ModalLevelKompetensi from "./modal-level-kompetensi.vue";
import ModalPemetaanLevelTaksonomi from "./modal-pemetaan-level-taksonomi.vue";

export default {
  page: {
    title: "Level Kompetensi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    ModalLevelKompetensi,
    ModalPemetaanLevelTaksonomi,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idlevel_kompetensi",
      },
      {
        width: "250px",
        label: "Nama Level",
        name: "nama_level",
      },
      {
        width: "auto",
        label: "Deskripsi Perilaku",
        name: "deskripsi_perilaku",
      },
      {
        width: "200px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    // Get hak akses
    const menu = "Level Kompetensi";

    return {
      title: menu,
      // isWrite: localStorage.getItem("isWrite"),
      isWrite: 1,
      showModal: false,
      isEdit: false,
      selected_id: "",
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "nama_level", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "nama_level",
        dir: "asc",
        filter: {
          active_flag: 1,
        },
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  async mounted() {
    this.getDataTable();
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/level-kompetensi",
    ) {
      this.loadingTable = true;

      var config = {
        method: "get",
        url: url,
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data_fix.data;
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
            this.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable();
    },
    edit(data) {
      this.isEdit = true;
      this.selected_id = data.idlevel_kompetensi;
      this.showModal = true;
    },
    onClose() {
      this.showModal = false;
      this.selected_id = null; // ← reset saat tutup
      this.isEdit = false;
    },
    onSaved() {
      this.onClose();
      this.getDataTable();
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-end gap-2">
              <button
                class="btn btn-warning btn-sm"
                @click="$refs.modalPemetaan.open()"
              >
                <i class="fa fa-list me-1"></i> Pemetaan
              </button>
            </div>
            <!-- <div class="row mt-2">
              <hr />
              <div class="form-group col-md-3">
                <label for="filterStatus">Status</label>
                <select
                  class="form-control"
                  id="filterStatus"
                  v-model="tableFilter.filter.active_flag"
                  @change="getDataTable()"
                >
                  <option value="1">Aktif</option>
                  <option value="0">Tidak Aktif</option>
                </select>
              </div>
            </div> -->
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getDataTable()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>

                <datatable
                  :columns="columns"
                  :sortKey="sortKey"
                  :sortOrders="sortOrders"
                  @sort="sortBy"
                >
                  <tbody>
                    <tr v-if="loadingTable">
                      <td class="text-center" colspan="99">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                      </td>
                    </tr>
                    <tr v-else-if="table_data == ''">
                      <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(row_data, key_data) in table_data"
                      :key="key_data"
                    >
                      <td>{{ key_data + pagination.from }}</td>
                      <td>
                        {{ row_data.nama_level }}
                      </td>
                      <td>
                        {{ row_data.deskripsi_perilaku }}
                      </td>
                      <td class="text-center">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            v-if="isWrite || isWrite == 1"
                            v-on:click="edit(row_data)"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </datatable>
              </div>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal
      v-model="showModal"
      :title="isEdit ? 'Edit Level Kompetensi' : 'Tambah Level Kompetensi'"
      title-class="text-black font-18"
      body-class="p-4"
      hide-footer
    >
      <ModalLevelKompetensi
        :selected_id="selected_id"
        @close="onClose"
        @saved="onSaved"
      />
    </b-modal>

    <ModalPemetaanLevelTaksonomi
      ref="modalPemetaan"
      @close="$refs.modalPemetaan.showModal = false"
    />
  </Layout>
</template>
